// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "footer#footer[data-v-16216525]{background-color:var(--footer-bg-color);color:var(--footer-header-color);margin-top:30px;padding:30px}footer#footer section a[data-v-16216525]{color:var(--footer-link-color)}footer#footer section[data-v-16216525]{text-align:center}footer#footer section a[data-v-16216525]{font-size:16px;-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
